$(function() {
  new Swiper('#hero-swiper', {
    slidesPerView: 1,
    spaceBetween: 100,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    allowTouchMove: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    } 
  });

  new Swiper('#info-slider', {
    slidesPerView: 1.5,
    loop: true,
    centeredSlides: true,
    allowTouchMove: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      767: {
          slidesPerView: 1.8,
      },
      991: {
          slidesPerView: 2.6,
      }
    }
  });
 });